/**
 * Icon name-to-emoji mapping.
 * Maps FontAwesome-style icon names (stored in DB seed) to emoji characters.
 * Used as fallback when the icon field contains a text name instead of an emoji.
 */
const ICON_NAME_TO_EMOJI = {
  // Income
  'money-bill': '💵',
  'briefcase': '💼',
  'laptop': '💻',
  'chart-line': '📈',
  'gift': '🎁',
  'undo': '↩️',
  'plus-circle': '➕',

  // Essentials
  'shopping-cart': '🛒',
  'home': '🏠',
  'bolt': '⚡',
  'wifi': '📶',
  'car': '🚗',
  'gas-pump': '⛽',

  // Health & Personal
  'hospital': '🏥',
  'shield': '🛡️',
  'spa': '💆',

  // Food & Dining
  'utensils': '🍽️',
  'coffee': '☕',

  // Shopping
  'tshirt': '👕',
  'blender': '🏠',

  // Entertainment
  'film': '🎬',
  'tv': '📺',
  'book': '📚',

  // Education
  'graduation-cap': '🎓',
  'certificate': '📜',

  // Financial
  'credit-card': '💳',
  'piggy-bank': '🐷',
  'file-invoice': '📋',

  // Others
  'hand-holding-heart': '🤲',
  'plane': '✈️',
  'tools': '🔧',
  'paw': '🐾',
  'minus-circle': '➖',
  'wallet': '👛',
  'category': '📁',
};

const DEFAULT_ICON = '📁';

/**
 * Resolves an icon value to a displayable emoji.
 * - If the value is already an emoji (non-ASCII), returns it as-is.
 * - If the value is a text icon name, maps it to an emoji.
 * - If unknown, returns a default icon.
 */
export function resolveIcon(iconValue) {
  if (!iconValue) return DEFAULT_ICON;

  // Check if the value is already an emoji (contains non-ASCII characters)
  // Emoji characters are outside the basic ASCII range (charCode > 127)
  const hasNonAscii = /[^\x00-\x7F]/.test(iconValue);
  if (hasNonAscii) return iconValue;

  // It's a text name — look up in map
  return ICON_NAME_TO_EMOJI[iconValue] || DEFAULT_ICON;
}

export default ICON_NAME_TO_EMOJI;
